"use strict";
/**
* AWTBondSerializer.ts
* Author: Brent Erickson (brericks) and Abhilash Panwar (abpanwar)
* Copyright: Microsoft 2016
* Class to handler bond serialization.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var Bond = require("../bond/microsoft.bond");
var Enums_1 = require("./Enums");
var Utils = require("./Utils");
var AWTBondSerializer = /** @class */ (function () {
    function AWTBondSerializer() {
    }
    AWTBondSerializer.getPayloadBlob = function (requestDictionary, tokenCount) {
        var stream = new Bond.IO.MemoryStream();
        var writer = new Bond.CompactBinaryProtocolWriter(stream);
        // Begin ClientCollector request
        //Write TokenToDataPackagesMap
        writer.WriteFieldBegin(Bond.BondDataType.BT_MAP, 3);
        writer.WriteMapContainerBegin(tokenCount, Bond.BondDataType.BT_STRING, Bond.BondDataType.BT_LIST);
        Object.keys(requestDictionary).forEach(function (token) {
            //write token
            writer.WriteString(token);
            var dataPackage = requestDictionary[token];
            // Write list of DataPackages
            writer.WriteContainerBegin(1, Bond.BondDataType.BT_STRUCT);
            // Source
            writer.WriteFieldBegin(Bond.BondDataType.BT_STRING, 2);
            writer.WriteString('act_default_source');
            // DataPackageId
            writer.WriteFieldBegin(Bond.BondDataType.BT_STRING, 5);
            writer.WriteString(Utils.newGuid());
            // Timestamp
            writer.WriteFieldBegin(Bond.BondDataType.BT_INT64, 6);
            writer.WriteInt64(Utils.numberToBondInt64(Date.now()));
            // Records
            writer.WriteFieldBegin(Bond.BondDataType.BT_LIST, 8);
            writer.WriteContainerBegin(dataPackage.length, Bond.BondDataType.BT_STRUCT);
            for (var i = 0; i < dataPackage.length; ++i) {
                writer.WriteBlob(dataPackage[i]);
            }
            writer.WriteStructEnd(false);
        });
        // End ClientCollector
        writer.WriteStructEnd(false);
        return stream.GetBuffer();
    };
    // As per mappings at https://skype.visualstudio.com/SCC/F.S4L.FUNDAMENTALS/_git/infrastructure_data_clienttelemetry?
    // path=%2Fclienttelemetry%2Fsrc%2Fbond%2FDataPackage.bond&version=GBdev2&_a=contents
    // Requires that the values of AWTEventData.properties must all be AWTEventProperty
    AWTBondSerializer.getEventBlob = function (eventData) {
        var stream = new Bond.IO.MemoryStream();
        var writer = new Bond.CompactBinaryProtocolWriter(stream);
        // ID
        writer.WriteFieldBegin(Bond.BondDataType.BT_STRING, 1);
        writer.WriteString(eventData.id);
        // Timestamp
        writer.WriteFieldBegin(Bond.BondDataType.BT_INT64, 3);
        writer.WriteInt64(Utils.numberToBondInt64(eventData.timestamp));
        // Type
        writer.WriteFieldBegin(Bond.BondDataType.BT_STRING, 5);
        writer.WriteString(eventData.type);
        // Event Type
        writer.WriteFieldBegin(Bond.BondDataType.BT_STRING, 6);
        writer.WriteString(eventData.name);
        var propsString = [];
        var piiProps = [];
        // Iterate across event data properties and separate based on pii
        Object.keys(eventData.properties).forEach(function (key) {
            var property = eventData.properties[key];
            if (property.pii === Enums_1.AWTPiiKind.NotSet) {
                propsString.push(key);
            }
            else {
                piiProps.push(key);
            }
        });
        //Extension map
        if (propsString.length) {
            writer.WriteFieldBegin(Bond.BondDataType.BT_MAP, 13);
            writer.WriteMapContainerBegin(propsString.length, Bond.BondDataType.BT_STRING, Bond.BondDataType.BT_STRING);
            propsString.forEach(function (name) {
                writer.WriteString(name);
                writer.WriteString(eventData.properties[name].value);
            });
        }
        // Pii
        if (piiProps.length) {
            writer.WriteFieldBegin(Bond.BondDataType.BT_MAP, 30);
            writer.WriteMapContainerBegin(piiProps.length, Bond.BondDataType.BT_STRING, Bond.BondDataType.BT_STRUCT);
            piiProps.forEach(function (name) {
                writer.WriteString(name);
                // PII Data
                // O365 scrubber type
                writer.WriteFieldBegin(Bond.BondDataType.BT_INT32, 1);
                writer.WriteInt32(1);
                // PII Kind
                writer.WriteFieldBegin(Bond.BondDataType.BT_INT32, 2);
                writer.WriteInt32(eventData.properties[name].pii);
                // Value
                writer.WriteFieldBegin(Bond.BondDataType.BT_STRING, 3);
                writer.WriteString(eventData.properties[name].value);
                writer.WriteStructEnd(false);
            });
        }
        writer.WriteStructEnd(false);
        return stream.GetBuffer();
    };
    AWTBondSerializer.base64Encode = function (data) {
        return Bond.Encoding.Base64.GetString(data);
    };
    return AWTBondSerializer;
}());
exports.default = AWTBondSerializer;
